import { EmptyState, Loader } from '@components';
import { DetailedResourceNodeFieldsFragment } from '@api/gql/graphql';
import { useInventoryPermissions } from '@Inventory/services/use-inventory-permissions';
import { useMemo } from 'react';
import { EntitlementsTable } from '@Inventory/components/EntitlementsTable';
import { getFragmentData } from '@api/gql';
import { PERMISSION_NODE_FIELDS_FRAGMENT } from '@Inventory/services/gql';
import { Stack, Typography } from '@mui/material';

export function EntitlementsTab({
  resource,
  query,
  entitlementsCount,
}: {
  resource: DetailedResourceNodeFieldsFragment;
  query: string;
  entitlementsCount?: string;
}) {
  const { data, isFetched, error, fetchNextPage, hasNextPage, isFetchingNextPage } = useInventoryPermissions(
    resource.id,
    { query },
  );

  const flatPermissions = useMemo(() => data?.pages.flatMap((page) => page.data) ?? [], [data]);
  const permissions = getFragmentData(PERMISSION_NODE_FIELDS_FRAGMENT, flatPermissions);

  if (!isFetched) return <Loader />;

  if (error || flatPermissions.length === 0) {
    return <EmptyState title="No Data Found" imgSrc="/static/EmptyStateImages/not-found-illustration.svg" />;
  }

  return (
    <Stack direction="column" spacing={2}>
      {entitlementsCount && (
        <Typography variant="body2" alignSelf="flex-end" color="text.muted">
          {entitlementsCount}
        </Typography>
      )}
      <EntitlementsTable
        resource={resource}
        hasMore={hasNextPage}
        permissions={[...permissions]}
        fetchMore={fetchNextPage}
        loading={isFetchingNextPage}
      />
    </Stack>
  );
}
